import React from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '../context/StoreContext';
import { useToast } from '../hooks/useToast';
import ToastContainer from '../components/Toast';
import ProductCard from '../components/ProductCard';

export default function WishlistPage() {
  const { wishlist, wishlistLoading, wishlistError, addToCart } = useStore();
  const { toasts, showToast } = useToast();

  const handleAddToCart = p => {
    addToCart({ ...p, variant: `${p.colors[0]} / ${p.sizes[0]}`, qty: 1 });
    showToast(`${p.name} added to cart`, 'fa-bag-shopping');
  };

  return (
    <div className="wishlist-wrapper">
      <div className="wishlist-hero">
        <div className="container">
          <h1 className="wishlist-title">
            My <em>Wishlist</em>
          </h1>
          <p className="wishlist-count">{wishlist.length} saved items</p>
        </div>
      </div>

      <div className="wishlist-content container">
        {wishlistLoading ? (
          <div className="empty-wishlist">
            <div className="empty-icon-box">
              <i className="fas fa-spinner fa-spin" />
            </div>
            <h3>Loading your wishlist</h3>
            <p>Please wait while we fetch your saved items.</p>
          </div>
        ) : wishlistError ? (
          <div className="empty-wishlist">
            <div className="empty-icon-box">
              <i className="fas fa-circle-exclamation" />
            </div>
            <h3>Unable to load wishlist</h3>
            <p>{wishlistError}</p>
            <Link to="/shop" className="btn-gold">Browse Products</Link>
          </div>
        ) : wishlist.length === 0 ? (
          <div className="empty-wishlist">
            <div className="empty-icon-box">
              <i className="far fa-heart" />
            </div>
            <h3>Your wishlist is empty</h3>
            <p>Save products you love to find them later</p>
            <Link to="/shop" className="btn-gold">Discover Products</Link>
          </div>
        ) : (
          <div className="row g-4">
            {wishlist.map(p => (
              <div key={p.id} className="col-6 col-md-4 col-lg-3">
                <ProductCard product={p} onAddToCart={handleAddToCart} />
              </div>
            ))}
          </div>
        )}
      </div>
      <ToastContainer toasts={toasts} />
    </div>
  );
}